import { RPPG_SCAN_DURATION_MS } from "services/rppg/api";

export type RppgEnv = "dev" | "stage" | "prod";

export interface MedsiScanRuntimeConfig {
  duration: number;
  env: RppgEnv;
  rppgApiKey: string;
  rppgBaseUrl: string;
}

function isLocalHostname(hostname: string): boolean {
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.startsWith("192.168.")
  );
}

export function getRppgEnv(hostname?: string): RppgEnv {
  const host =
    hostname ?? (typeof window !== "undefined" ? window.location.hostname : "");

  if (host.indexOf("stage") >= 0) {
    return "stage";
  }
  if (host.indexOf("dev") >= 0 || isLocalHostname(host)) {
    return "dev";
  }
  return "prod";
}

function getRppgBaseUrl(env: RppgEnv): string {
  switch (env) {
    case "dev":
      return process.env.REACT_APP_RPPG_BASE_URL ?? "";
    case "stage":
      return process.env.REACT_APP_STAGE_API_BASE_URL ?? "";
    case "prod":
      return process.env.REACT_APP_PROD_API_BASE_URL ?? "";
  }
}

function getRppgApiKey(env: RppgEnv): string {
  switch (env) {
    case "dev":
      return process.env.REACT_APP_DEV_RPPG_API_KEY ?? "";
    case "stage":
      return process.env.REACT_APP_STAGE_RPPG_API_KEY ?? "";
    case "prod":
      return process.env.REACT_APP_PROD_RPPG_API_KEY ?? "";
  }
}

export function getMedsiScanConfig(): MedsiScanRuntimeConfig {
  const env =
    typeof window !== "undefined"
      ? getRppgEnv(window.location.hostname)
      : "prod";

  return {
    env,
    duration: RPPG_SCAN_DURATION_MS / 1000,
    rppgBaseUrl: getRppgBaseUrl(env),
    rppgApiKey: getRppgApiKey(env),
  };
}
